import React, { useState } from 'react';
import { Title, Skeleton, Button } from '@gerdau/hefesto';
import ProductList from './ProductList';
import ResultGraph from './ResultGraph';
import SearchProduct from './SearchProduct';
import { Container } from './styles';
import {
  ILoyaltyProduct,
  ILoyaltyProductList
} from '../../../store/ducks/loyalty/types';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../routes';

const LoyaltySimulator: React.FC = () => {
  const history = useHistory();
  const loyalty = useSelector((appState: ApplicationState) => appState.loyalty);
  const [productList, setProductList] = useState<ILoyaltyProductList[]>([]);

  const addProductToProductList = (newProduct: ILoyaltyProduct) => {
    const newProductList = JSON.parse(
      JSON.stringify(productList)
    ) as ILoyaltyProductList[];

    const newProductIdx = newProductList.findIndex(
      (p) => p.product.sku === newProduct.sku
    );

    if (newProductIdx === -1) {
      newProductList.push({
        product: newProduct,
        qty: 1,
        qty_type: 'kg'
      });
    } else {
      newProductList[newProductIdx].qty++;
    }
    setProductList(newProductList);
  };

  const deleteProduct = (idx: number) => {
    const newProductList = JSON.parse(
      JSON.stringify(productList)
    ) as ILoyaltyProductList[];
    newProductList.splice(idx, 1);
    setProductList(newProductList);
  };

  const updateItemQty = (idx: number, qty: number) => {
    const newProductList = JSON.parse(
      JSON.stringify(productList)
    ) as ILoyaltyProductList[];
    newProductList[idx] = {
      product: newProductList[idx].product,
      qty: qty,
      qty_type: newProductList[idx].qty_type
    };
    setProductList(newProductList);
  };
  const updateItemQtyType = (idx: number, qty_type: string) => {
    const newProductList = JSON.parse(
      JSON.stringify(productList)
    ) as ILoyaltyProductList[];
    newProductList[idx] = {
      product: newProductList[idx].product,
      qty: newProductList[idx].qty,
      qty_type: qty_type
    };
    setProductList(newProductList);
  };
  const [percentage, setPercentage] = useState(0);
  return (
    <div>
      <Container>
        <div className="left-side">
          <div className="left-top-side">
            <Title level={2}>Produtos</Title>
            <hr></hr>
          </div>
          <div className="left-bot-side">
            <ProductList
              productList={productList}
              deleteProduct={(idx: number) => deleteProduct(idx)}
              updateQty={(idx: number, qty: number) => updateItemQty(idx, qty)}
              updateQtyType={(idx: number, qty_type: string) =>
                updateItemQtyType(idx, qty_type)
              }
            ></ProductList>
            <div className="search-container">
              <SearchProduct
                addProductToProductList={addProductToProductList}
                productList={productList}
              ></SearchProduct>
            </div>
          </div>
        </div>

        <div className="right-side">
          {loyalty.simulate.loading && <Skeleton type="input" />}
          {!loyalty.simulate.loading && (
            <div>
              <div className="right-top-side">
                <Title level={2}>Resultado</Title>
                <hr></hr>
              </div>
              <div className="right-bot-side">
                <ResultGraph
                  percentage={percentage}
                  setPercentage={setPercentage}
                />

                <Button
                  onClick={() => {
                    history.push(`${ERoutes.PURCHASE}`);
                  }}
                  name="orders"
                  disabled={percentage < 100}
                  variant="secondary"
                >
                  Fazer novo pedido
                </Button>
              </div>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default LoyaltySimulator;
